type TBuildBreadcrumbItemsParams = {
  data: any;
  articlePath: string;
  product: string;
  onClick?: (link: string) => void;
};

export function buildBreadcrumbItems({
  articlePath,
  data,
  onClick,
  product,
}: TBuildBreadcrumbItemsParams) {
  try {
    const items = data.map(
      (item: { id: number; title: string; path: string }) => {
        const formattedItem = {
          id: item.id,
          text: item.title,
        };
        const categoryPath = item.path.split("/").slice(1).join("/");
        const isLastItem = item.path === articlePath;
        if (isLastItem) {
          return formattedItem;
        }
        const url = new URL(`/kb/articles/${product}`, "http://localhost");
        if (categoryPath) {
          url.searchParams.append("categoryPath", categoryPath);
        }
        const link = `${url.pathname}${url.search}`;
        return {
          ...formattedItem,
          onClick: onClick?.(link),
          link,
        };
      }
    );
    return items;
  } catch (error) {
    return [];
  }
}
